import { createSlice } from "@reduxjs/toolkit";
import { createStepForStepWiseSolution } from "../../../utils";

const INITIAL_QUESTION_BENCHMARK_FIELD = {
  goalLevel: { name: "", id: "" },
  course: { name: "", id: "" },
  isDeleted: false,
  isInitiallySelected: false,
};

const INITIAL_QUESTION_BENCHMARK_DATA = {
  benchmarks: [],
  errors: [],
  forceUpdate: false,
}

export const EMPTY_STEPWISE_SOLUTION_OF_QUESTION = [{
  formulaUsed: '',
  solutionSteps: [createStepForStepWiseSolution()]
}]

const questionSlice = createSlice({
  name: "counter",
  initialState: {
    aclMetaData: null,
    completionPercent: 0,
    contentId: "",
    contentReviewer: null,
    content_Id: "", // ?
    difficultyLevel: [],
    difficultyType: [],
    allRelevantExams: [],
    relevantExams: [],
    allPreviousExams: [],
    favourites: [], // ?
    subjects: [],
    secondarySubjects: [],
    tags: [],
    editRights: [],
    title: "",
    updatedAt: null,
    _id: "",
    conceptCode: [], // ?
    conceptId: [], // ?
    concepts: [], // ?
    questionType: "",
    matrixOptionContent: {
      optionLeft: [
        { id: "Left1", value: "", serialNo: 1 },
        { id: "Left2", value: "", serialNo: 2 },
        { id: "Left3", value: "", serialNo: 3 },
        { id: "Left4", value: "", serialNo: 4 },
      ],
      optionRight: [
        { id: "Right1", value: "", serialNo: 1 },
        { id: "Right2", value: "", serialNo: 2 },
        { id: "Right3", value: "", serialNo: 3 },
        { id: "Right4", value: "", serialNo: 4 },
        { id: "Right5", value: "", serialNo: 5 },
      ],
    },
    customAnswer: false,
    correctAnswer: { answerType: "id", data: [] },
    matrixCorrectAnswer: { answerType: "id", data: [] },
    optionsContent: [
      { id: "A", value: "", serialNo: 1 },
      { id: "B", value: "", serialNo: 2 },
      { id: "C", value: "", serialNo: 3 },
      { id: "D", value: "", serialNo: 4 },
    ],
    defaultCorrectAnswer: { answerType: "id", data: [] },
    alternateAnswer: false, // only needed in re-publish (add to queue)
    solutionContent: "",
    stepWiseSolution: [EMPTY_STEPWISE_SOLUTION_OF_QUESTION],
    activeStepWiseSolution:[0],
    questionHints: "",
    validations: null,
    draftId: null,
    isValidAttempts: false,
    idealTime: {value: '', state: 2},
    questionBenchmarks: {},
    publishedContent: null ,// { [questionId]: benchmarks data }
    questionPreviousExams:{},
    updateRelevantExam: true,
    selectedGoals: {},
    specialPurposes: [],
    syllabusExams: {},
    finalQuestionBenchmarksPayload: {},
    ftreRelevantExam: [],
    validatorFields: false,
    remedialQuestionIds: {}
  },
  reducers: {
    setTitle: (state, actionType) => {
      return { ...state, title: actionType.payload };
    },
    setMatrixOptionsContent: (state, actionType) => {
      return { ...state, matrixOptionContent: actionType.payload };
    },
    setMatrixCorrectAnswer: (state, actionType) => {
      return { ...state, correctAnswer: actionType.payload };
    },
    setRemedialQuestionIds: (state, actionType) => {
      state.remedialQuestionIds = actionType.payload;
    },
    setOptionsContent: (state, actionType) => {
      return { ...state, optionsContent: actionType.payload };
    },
    setCorrectAnswer: (state, actionType) => {
      return { ...state, correctAnswer: actionType.payload };
    },
    setCustomAnswer: (state, actionType) => {
      return { ...state, customAnswer: actionType.payload };
    },
    setSubjects: (state, actionType) => {
      return { ...state, subjects: actionType.payload };
    },
    setSecondarySubjects: (state, action) => {
      state.secondarySubjects = action.payload;
    },
    setSolutionContent: (state, actionType) => {
      return { ...state, solutionContent: actionType.payload };
    },
    setSpecialPurposes: (state, actionType) => {
      return { ...state, specialPurposes: actionType.payload };
    },
    setStepWiseSolutions: (state, action) => {
      const activeSolution=[]; 
      const initialData = action.payload.map(solutionsOfAQuestion => {
        activeSolution.push(0);
        return solutionsOfAQuestion.map((solution) => {
          const { solutionSteps } = solution;
          if(solutionSteps && solutionSteps.length === 0) {
            return { ...solution, solutionSteps: [createStepForStepWiseSolution()] };
          }
          
          return solution;
        });
      })
      state.stepWiseSolution = initialData;
      state.activeStepWiseSolution =activeSolution;
    },
    initialiseNoOfStepWiseSolutionForQuestions: (state, action) => {
      const noOfQuestions = action.payload;
      const solutions = [];
    const activeSolution=[];
      for(let i =0;i<noOfQuestions;i++) {
        solutions.push(EMPTY_STEPWISE_SOLUTION_OF_QUESTION);
        activeSolution.push(0);
        
      }
     
      state.stepWiseSolution = solutions;
      state.activeStepWiseSolution =activeSolution;
    },
    setActiveStepSolution:(state,action)=>{
      const { questionIndex = 0,tabNo } = action.payload;
    // state.activeStepWiseSolution[questionIndex] = tabNo;
 state.activeStepWiseSolution = state.activeStepWiseSolution.map((tab,index)=>{
   if(index === questionIndex){
     return tabNo;
   }
   return tab;
 })
    },
    addStepWiseSolution: (state, action) => {
      const { questionIndex = 0 } = action.payload;
      const solution = {
        formulaUsed: '',
        solutionSteps: [createStepForStepWiseSolution()]
      }
      state.stepWiseSolution[questionIndex].push(solution);
       state.activeStepWiseSolution[questionIndex]=state.stepWiseSolution[questionIndex].length-1;
        },
    deleteStepWiseSolution: (state, action) => {
      const { solutionNo, questionIndex = 0 } = action.payload;
      state.stepWiseSolution[questionIndex].splice(solutionNo, 1);
      state.activeStepWiseSolution[questionIndex]-=1;
    },
    editFormulaUsedForSolution: (state, action) => {
  const { value, questionIndex = 0} = action.payload;
  const solutionNo = state.activeStepWiseSolution[questionIndex];
     state.stepWiseSolution[questionIndex][solutionNo].formulaUsed = value;
    },
    addStepOfStepWiseSolution: (state, action) => {
      const { solutionNo, questionIndex = 0 } = action.payload;
      const newStepNo = state.stepWiseSolution[questionIndex][solutionNo].solutionSteps.length + 1;
      const step = createStepForStepWiseSolution(newStepNo);
      state.stepWiseSolution[questionIndex][solutionNo].solutionSteps.push(step)
     },
    editStepOfStepWiseSolution: (state, action) => {
      const { solutionNo, stepNo, updates, questionIndex = 0 } = action.payload;
   
      const step = state.stepWiseSolution[questionIndex][solutionNo].solutionSteps[stepNo];
      state.stepWiseSolution[questionIndex][solutionNo].solutionSteps[stepNo] = { ...step, ...updates };
    },
    deleteStepOfStepWiseSolution: (state, action)=> {
      const { solutionNo, stepNo, questionIndex } = action.payload;
      state.stepWiseSolution[questionIndex][solutionNo].solutionSteps.splice(stepNo, 1);
      state.stepWiseSolution[questionIndex][solutionNo].solutionSteps.forEach((solutionStep, i) => {
        solutionStep.stepNo = i+1;
      });
    },
    setQuestionHints: (state, actionType) => {
      return { ...state, questionHints: actionType.payload };
    },
    setDifficultyLevel: (state, actionType) => {
      return { ...state, difficultyLevel: actionType.payload };
    },
    setDifficultyType: (state, actionType) => {
      return { ...state, difficultyType: actionType.payload };
    },
    setAllRelevantExams: (state, actionType) => {
        return { ...state, allRelevantExams: actionType.payload }
    },
    setAllPreviousExams: (state, actionType) => {
      return { ...state, allPreviousExams: actionType.payload }
    },
    setRelevantExams: (state, actionType) => {
        return { ...state, relevantExams: actionType.payload }
    },
    setTags: (state, actionType) => {
      return { ...state, tags: actionType.payload };
    },
    setEditRights: (state, actionType) => {
      return { ...state, editRights: actionType.payload };
    },
    setValidations: (state, actionType) => {
      return { ...state, validations: actionType.payload };
    },
    setDraftId: (state, actionType) => {
      return { ...state, draftId: actionType.payload };
    },
    setAlternateAnswer: (state, actionType) => {
      return { ...state, alternateAnswer: actionType.payload };
    },
    setDefaultCorrectAnswer: (state, actionType) => {
      return { ...state, defaultCorrectAnswer: actionType.payload };
    },
    setIsValidAttempts: (state, actionType) => {
      return { ...state, isValidAttempts: actionType.payload };
    },
    setIdealTime: (state, actionType) => {
      return { ...state, idealTime: actionType.payload }
    },
    initialiseQuestionBenchmarks: (state, action) => {
      const { questionId } = action.payload;
      if(!state.questionBenchmarks.hasOwnProperty(questionId)) {
        state.questionBenchmarks[questionId] = {...INITIAL_QUESTION_BENCHMARK_DATA};
      }
    },
    setQuestionBenchmarks: (state, action) => {
      const { questionId, data } = action.payload
      state.questionBenchmarks[questionId].benchmarks = data;
    },
    setFinalQuestionBenchmarksPayload: (state, action) => {
      const { questionId, benchmarks } = action.payload;
      state.finalQuestionBenchmarksPayload[questionId] = benchmarks;
    },
    editQuestionBenchmarks: (state, action) => {
      const {
        payload: { fieldType, index, value, questionId },
      } = action;
      
      if (fieldType === "course") {
        state.questionBenchmarks[questionId].benchmarks[index].course = value;
        state.questionBenchmarks[questionId].benchmarks[index].goalLevel =
          INITIAL_QUESTION_BENCHMARK_FIELD.goalLevel;
      } else if (fieldType === "goalLevel") {
        state.questionBenchmarks[questionId].benchmarks[index].goalLevel = value;
      }
      // reset any error on the field of fieldType
      if (state.questionBenchmarks[questionId].errors[index]) {
        state.questionBenchmarks[questionId].errors[index][fieldType] = "";
      }
    },
    removeAllQuestionBenchmarks: (state, action) => {
      const { questionId } = action.payload;
      const initiallySelectedBenchmarks = state.questionBenchmarks[questionId].benchmarks.filter(
        ({ isInitiallySelected }) => isInitiallySelected
      );
      if (initiallySelectedBenchmarks.length > 0) {
        state.questionBenchmarks[questionId].benchmarks = initiallySelectedBenchmarks.map(
          (benchmark) => ({ ...benchmark, isDeleted: true })
        );
        // Add empty questionBenchmarks field when all were initially selected
          state.questionBenchmarks[questionId].benchmarks.unshift(
            INITIAL_QUESTION_BENCHMARK_FIELD
          );
      } else {
        state.questionBenchmarks[questionId].benchmarks = [
        ];
      }
      state.questionBenchmarks[questionId].errors = [];
    },
    resetQuestionBenchmarks: (state, action) => {
      const { questionId } = action.payload
      state.questionBenchmarks[questionId].benchmarks = [INITIAL_QUESTION_BENCHMARK_FIELD];
      state.questionBenchmarks[questionId].errors = [];
      state.questionBenchmarks[questionId].forceUpdate = false;
    },
    setQuestionBenchmarkErrors: (state, action) => {
      const { questionId, data } = action.payload
      state.questionBenchmarks[questionId].errors = data;
    },
    setForceQuestionBenchmarkUpdate: (state, action) => {
      const { questionId, data } = action.payload
      state.questionBenchmarks[questionId].forceUpdate = data;
    },
    addQuestionBenchmarkField: (state, action) => {
      const { questionId } = action.payload
      state.questionBenchmarks[questionId].benchmarks.push(
        INITIAL_QUESTION_BENCHMARK_FIELD
      );
    },
    removeQuestionBenchmarkField: (state, action) => {
      const { index, questionId } = action.payload;
      const benchmark = state.questionBenchmarks[questionId].benchmarks[index];
      if (benchmark.isInitiallySelected) {
        // if benchmark was already saved, send isDeleted=true for it
        benchmark.isDeleted = true;
      } else {
        // if it was not saved then delete it from the array
        state.questionBenchmarks[questionId].benchmarks = state.questionBenchmarks[questionId].benchmarks.filter(
          (_, i) => i !== index
        );
      }
      // remove any error of the field
      state.questionBenchmarks[questionId].errors = state.questionBenchmarks[questionId].errors.filter(
        (_, i) => i !== index
      );
      // const nonDeletedBenchmarks = state.questionBenchmarks[questionId].benchmarks.filter(
      //   ({ isDeleted }) => !isDeleted
      // );
      // if (nonDeletedBenchmarks.length === 0) {
      //   state.questionBenchmarks[questionId].benchmarks.unshift(
      //     INITIAL_QUESTION_BENCHMARK_FIELD
      //   );
      // }
    },
    setPreviousExam:(state, action) => {
      const { questionId, data } = action.payload
      state.questionPreviousExams[questionId] = data;
    },
    setPublishedContent: (state, actionType) => {
      return { ...state, publishedContent: actionType.payload }
    },
    setUpdateRelevantExam: (state, actionType) => {
      return { ...state, updateRelevantExam: actionType.payload };
    },
    setSelectedGoals: (state, actionType) => {
      return { ...state, selectedGoals: { ...state.selectedGoals, ...actionType.payload } };
    },
    setSyllabusExams: (state, actionType) => {
      const { qId, selectedExams } = actionType.payload;
      state.syllabusExams[qId] = selectedExams;
    },
    setFtreRelevantExam: (state, actions) => {
      state.ftreRelevantExam = actions.payload;
    },
    setValidatorFields:(state,actions)=>{
      state.validatorFields = actions.payload;
    }
  },
});

const { actions, reducer } = questionSlice;

export default reducer;
export const questionActions = actions;